import contract from "@/http/requests/contract"

export default {
  contractInfos({ commit }) {
    return new Promise((resolve, reject) => {
      contract.contractInfos().then(response => {
        commit('SET_CONTRACT', response.data.data.contractInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  signContract() {
    return new Promise((resolve, reject) => {
      contract.signContract().then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
